import RemoveRowCellRenderer from "./RemoveRowCellRenderer";

export default class EmptyRemoveRowCellRenderer extends RemoveRowCellRenderer {
    generateContent(cell) {
        //do nothing
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/EmptyRemoveRowCellRenderer.js